import type { DataTableColumn } from '@/components/custom/erp';
import type { Lo, VatTu } from '@/types/schemas';

type LotTableRow = Lo & {
  ma_vt_data?: Pick<VatTu, 'ma_vt'> | null;
};

export const getDataTableColumns = (): DataTableColumn<LotTableRow>[] => {
  return [
    {
      field: 'ma_vt',
      headerName: 'Mã vật tư',
      width: 120,
      renderCell: params => {
        return params.row.ma_vt_data?.ma_vt || '';
      }
    },
    {
      field: 'ma_lo',
      headerName: 'Mã lô',
      width: 120
    },
    {
      field: 'ten_lo',
      headerName: 'Tên lô',
      width: 250
    },
    {
      field: 'ngay_sx',
      headerName: 'Ngày sản xuất',
      width: 120
    },
    {
      field: 'ngay_hhsd',
      headerName: 'Hạn sử dụng',
      width: 120
    }
  ];
};

export const statusOptions = [
  { value: '1', label: '1. Còn sử dụng' },
  { value: '0', label: '0. Không sử dụng' }
];
